import { BaseApi } from '@/main/baseApi';
import { NAME as VOZIDLO } from '@/modules/kartoteka/vozidlo/constants';
import { DMS_MODULE as KARTOTEKA, PARTNER } from '@/modules/kartoteka/constants';
import { NAME as ZAKAZKA, SERVICE_PKG_PARTS, SERVICE_PKG_LABOR } from '@/modules/servis/zakazka/constants';
import { NAME as ZAKAZKALIST } from '@/modules/servis/zakazka/zakazkovyList/constants';
import { OZAKAZKA_ND, ZAKAZKA_ND, OZAKAZKA } from '@/modules/servis/constants';
import { NAME as ZAKAZKA_PRACOVNI_POZICE } from '@/modules/servis/zakazka/pracovniPozice/constants';

import {
	DependentTableNames,
	DMS_MODULE,
	MERGE_VOZIDLO,
	MERGE_ZAKAZNIK,
	NAME,
	ND,
	PRACOVNI_POZICE,
	ZAKAZKY_ESHOP_LIST,
	ZAKAZKY_LIST,
	POLOZKY,
	ZAKAZKA_ND_PENDING,
	ZAKAZKA_PP_PENDING,
	CAMPAIGN_DETAILS,
	OrderReports,
	PLANNED_ORDER_SERVICE_JOB,
} from './constants';

export const ozakazkaReportUrl = `/${DMS_MODULE}/Reports/Reports/GetOzakazkaReport`;

type reportOptions = {
	[key: string]: string
};

const reportEnumToApi : reportOptions = {
	[OrderReports.ServiceEstimation]: `/${DMS_MODULE}/Reports/GetServiceEstimationReport`,
	[OrderReports.VehicleReceptionChecklistReport]: `/${DMS_MODULE}/Reports/GetVehicleReceptionChecklistReport`,
};
class OzakazkaProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case ND:
				return `/${this.area}/${OZAKAZKA_ND}/Schema`;
			case ZAKAZKA_ND_PENDING:
				return `/${this.area}/${ZAKAZKA_ND_PENDING}/Schema`;
			case ZAKAZKA_PP_PENDING:
				return `/${this.area}/${ZAKAZKA_PP_PENDING}/Schema`;
			case PRACOVNI_POZICE:
				return `/${this.area}/${NAME}/PracovniPoziceSchema`;
			case ZAKAZKY_LIST:
				return `/${this.area}/${ZAKAZKA}/SelectSchema`;
			case ZAKAZKY_ESHOP_LIST:
				return `/${this.area}/${ZAKAZKA}/ZakazkaEshopSchema`;
			case MERGE_ZAKAZNIK:
				return `/${KARTOTEKA}/${PARTNER}/MergeSchema`;
			case MERGE_VOZIDLO:
				return `/${KARTOTEKA}/${VOZIDLO}/MergeSchema`;
			case SERVICE_PKG_PARTS:
				return `/${this.area}/${SERVICE_PKG_PARTS}/Schema`;
			case CAMPAIGN_DETAILS:
				return `/${this.area}/${CAMPAIGN_DETAILS}/Schema`;
			case SERVICE_PKG_LABOR:
				return `/${this.area}/${SERVICE_PKG_LABOR}/Schema`;
			case POLOZKY:
				return `/${this.area}/${ZAKAZKALIST}/${POLOZKY}Schema`;
			case PLANNED_ORDER_SERVICE_JOB:
				return `/${this.area}/${OZAKAZKA}/${PLANNED_ORDER_SERVICE_JOB}Schema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case ND:
				return `/${this.area}/${OZAKAZKA_ND}/`;
			case ZAKAZKA_ND_PENDING:
				return `/${this.area}/${ZAKAZKA_ND_PENDING}/`;
			case ZAKAZKA_PP_PENDING:
				return `/${this.area}/${ZAKAZKA_PP_PENDING}/`;
			case PRACOVNI_POZICE:
				return `/${this.area}/${NAME}/PracovniPoziceRows`;
			case ZAKAZKY_LIST:
				return `/${this.area}/${ZAKAZKA}/SelectRows`;
			case ZAKAZKY_ESHOP_LIST:
				return `/${this.area}/${ZAKAZKA}/ZakazkaEshopRows`;
			case MERGE_ZAKAZNIK:
				return `/${KARTOTEKA}/${PARTNER}/MergeRows`;
			case MERGE_VOZIDLO:
				return `/${KARTOTEKA}/${VOZIDLO}/MergeRows`;
			case SERVICE_PKG_PARTS:
				return `/${this.area}/${SERVICE_PKG_PARTS}`;
			case SERVICE_PKG_LABOR:
				return `/${this.area}/${SERVICE_PKG_LABOR}`;
			case CAMPAIGN_DETAILS:
				return `/${this.area}/${CAMPAIGN_DETAILS}`;
			case POLOZKY:
				return `/${this.area}/${ZAKAZKALIST}/${POLOZKY}Rows`;
			case PLANNED_ORDER_SERVICE_JOB:
				return `/${this.area}/${OZAKAZKA}/${PLANNED_ORDER_SERVICE_JOB}Rows`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	async createZakazka(ozakazkaId: any, vPriprave: boolean, checkinId: number, druhZakazky: string | null = null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CreateZakazka`, { ozakazkaId, vPriprave, checkinId, druhZakazky });
	}

	async ozakazkaOnVozidlo(Spz: string, ZakaznikId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/OzakazkaOnVozidlo`, { Spz, ZakaznikId });
	}

	async zakaznickaSkupinaChange(oZakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaZakaznickaSkupina`, oZakazka);
	}

	async fakturacniProfilChange(oZakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaFakturaceProfil`, oZakazka);
	}

	async vozidloChange(oZakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaVozidlo`, oZakazka);
	}

	async updateDiscountForAllParts(OzakazkaId: any, DiscountPercent:any) {
		return this.post(`/${DMS_MODULE}/${NAME}/UpdateDiscountToAllParts?discountPercent=${DiscountPercent}&plannedOrderId=${OzakazkaId}`);
	}

	async zakaznikChange(oZakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ZmenaZakaznik`, oZakazka);
	}

	createLabor(zakazkaId: number, ServicePackageId: number, VehicleId: number) {
		this.fetch(`/${DMS_MODULE}/${ZAKAZKA_PRACOVNI_POZICE}/CreateLabor`, { zakazkaId, ServicePackageId, VehicleId });
	}

	createParts(zakazkaId: number, ServicePackageId: number, VehicleId: Number) {
		this.fetch(`/${DMS_MODULE}/${ZAKAZKA_ND}/InsertServicePkgParts`, { zakazkaId, ServicePackageId, VehicleId });
	}

	deletePackage(OzakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/DeleteServicePackage`, { OzakazkaId });
	}

	deletePackageLabor(OzakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${ZAKAZKA_PRACOVNI_POZICE}/DeleteServicepackageLabor`, { OzakazkaId });
	}

	deletePackageParts(OzakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/ZakazkaRezervaceNd/DeleteServicePkgParts`, { OzakazkaId });
	}

	getOzakazkaReport(filter: any) {
		return this.fetchPdf(`/${DMS_MODULE}/Reports/GetOzakazkaReport`, { id: filter });
	}

	cancelOrder(zakazkaId: number, OzakazkaId: number, comments: string, cancelType: number, cancelRemarks: string) {
		return this.fetch(`/${DMS_MODULE}/${ZAKAZKA}/CancelOrder`, { zakazkaId, OzakazkaId, comments, cancelType, cancelRemarks });
	}

	rescheduleOrderUpdate(OzakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/RescheduleOrderUpdate`, { OzakazkaId });
	}

	rescheduleOrder(zakazkaId: number, ozakazkaId: number, comments: string, planDate: Date, deliveryDate: Date) {
		return this.fetch(`/${DMS_MODULE}/${ZAKAZKA}/RescheduleOrder`, { zakazkaId, ozakazkaId, comments, planDate, deliveryDate });
	}

	getGatePassServisReport(filter: {}) {
		return this.fetchPdf(`/${DMS_MODULE}/Reports/GetGatePass`, filter);
	}

	orderSubTypeCheck(VozidloId: number, OrderSubtypeId: number, OzakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/OrderSubTypeCheck?VozidloId=${VozidloId}&OrderSubtypeId=${OrderSubtypeId}&OzakazkaId=${OzakazkaId}`);
	}

	async isVehicleInward(OzakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsVehicleInward`, { OzakazkaId });
	}

	async sendWatchlistedEmail(ozakazka: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendWatchlistedEmail`, ozakazka);
	}

	async isOrderCreated(OzakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsOrderCreated`, { OzakazkaId });
	}

	async IsDateCompareNeeded(OzakazkaId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsDateCompareNeeded`, { OzakazkaId });
	}

	markReportAsPrinted(id: number, reportType: string) {
		return this.post(`/Servis/Zakazka/MarkAsPrint?id=${id}&reportType=${reportType}`);
	}

	async getTimeUnit(vehicleId: number, ppNr: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetTimeUnit?vehicleId=${vehicleId}&ppNr=${ppNr}`);
	}

	async getCustomerDetails(vehicleId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetCustomerDetails?vehicleId=${vehicleId}`);
	}

	async getPartsList(vehicleBrand: string[], wareHouse:string, partCategory: string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPartsList?SkladOzn=${wareHouse}&HledejPodretezecNdNr=true&VehicleBrand=${vehicleBrand}&VyrobekndOzn=${partCategory}`);
	}

	async getPartsListByPlanOrder(brand: string, planOrderId: number, vehicleBrand: string[]) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPartsList?PlanOrderId=${planOrderId}&HledejPodretezecNdNr=true&VyrobekndOzn=${brand}&VehicleBrand=${vehicleBrand}`);
	}

	async getPartsPrice(ndNr: string, orderId: number, warehouseId: number | null) {
		return this.fetch(`/Nd/NdSklad/NdSkladByPartNumber?partNumber=${ndNr}&isPlannedOrder=true&orderId=${orderId}&warehouseId=${warehouseId}`);
	}

	async getServiceJobs(vozidloId: number, workshopId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetServiceJobs`, { vozidloId, workshopId });
	}

	getReport(filter: object, ReportID: string) {
		return this.fetchPdf(`${reportEnumToApi[ReportID]}`, filter);
	}

	async updateServiceJobsAtAllLevel(plannedOrderId: number, orderId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/updateServiceJobsAtAllLevel?OzakazkaId=${plannedOrderId}&ZakazkaId=${orderId}`);
	}

	async getPricingDate(partNo: string, brand:string, orderId:number | null, warehouseId: number) {
		return this.fetch(`/${DMS_MODULE}/${ZAKAZKA_ND}/GetMrp?partNo=${partNo}&brand=${brand}&orderId=${orderId}&warehouseId=${warehouseId}`);
	}

	async getNdpPricing(localRrp: number, partNo:string, brand:string, wareHouse:number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetNdp?localRrpId=${localRrp}&NdNr=${partNo}&Brand=${brand}&WareHouse=${wareHouse}`);
	}

	async updateDiscountToAllLabor(discountPercent: any, plannedOrderId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/UpdateDiscountToAllLabor?discountPercent=${discountPercent}&plannedOrderId=${plannedOrderId}`);
	}

	async getPlannedLevelLaborPrice(plannedOrderId: number, laborCode: string, timeUnit: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPlannedLevelLaborPrice?plannedOrderId=${plannedOrderId}&laborCode=${laborCode}&timeUnit=${timeUnit}`);
	}

	async getPlannedLevelLaborPriceWithCC(plannedOrderId: number, laborCode: string, timeUnit: number, costCenterId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPlannedLevelLaborPrice?plannedOrderId=${plannedOrderId}&laborCode=${laborCode}&timeUnit=${timeUnit}&costCenterId=${costCenterId}`);
	}

	getCustomerByGoldenAccountId(customerId: number | null, vin: string | null, refreshflag: number | null) {
		return this.fetch(`Kartoteka/Partner/getCustomerByGoldenAccountId?customerId=${customerId}&vin=${vin}&refreshflag=${refreshflag}`);
	}

	async getPartQuantity(partNo:string, brand:string, wareHouse:number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPartQuantity?partNo=${partNo}&brand=${brand}&wareHouse=${wareHouse}`);
	}

	managePlannedOrderOperations(PlannedOrderId: number, ManagePlannedOrderDto: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/ManagePlannedOrderOperations/${PlannedOrderId}`, ManagePlannedOrderDto);
	}

	async UpdateCustomerMemo(OzakazkaId: number, Memo: string) {
		return this.post(`/${DMS_MODULE}/${NAME}/UpdateCustomerMemo?ozakazkaId=${OzakazkaId}&memo=${Memo}`);
	}

	async CheckHoliday(workshopId:number, planDate:any) {
		return this.fetch('/Administrace/Holiday/CheckHoliday', { workshopId, planDate });
	}

	async checkIsDealerCustomer(orderId:number | null) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CheckIsDealerCustomer?orderId=${orderId}`);
	}

	async getRrpUnitPrice(partNo: string, brand:string, warehouseId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetRrpUnitPrice?partNo=${partNo}&brand=${brand}&warehouseId=${warehouseId}`);
	}

	async isPlannedOrderConverted(PlannedOrderId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/IsPlannedOrderConverted`, { PlannedOrderId });
	}

	deletePart(partId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/DeletePart`, { partId });
	}

	deletelabor(laborId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/Deletelabor`, { laborId });
	}

	deleteServiceJob(serviceJobId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/DeleteServiceJob`, { serviceJobId });
	}
	
	async AssignWorkshopOrder(plannedOrderId: number | null) {
		return this.post(`Servis/Zakazka/AssignWorkshopOrder?orderId=0&plannedOrderId=${plannedOrderId}`);
	}

	async GetWorkshopOrder(plannedOrderId: number | null) {
		return this.post(`Servis/Zakazka/GetWorkshopOrder?orderId=0&plannedOrderId=${plannedOrderId}`);
	}

	async GenerateElsaProOrderId(plannedOrderId: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/GenerateElsaProOrderId?plannedOrderId=${plannedOrderId}`);
	}

	async saveCustomerContactDetails(customerInputDTO: object) {
		return this.post(`Kartoteka/Partner/InsertCustomerContact`, customerInputDTO);
	}

	async GetOrderContactDetails(orderId: number, isServiceOrder: boolean) {
		return this.fetch(`Kartoteka/Partner/GetOrderContactDetails?orderId=${orderId}&isServiceOrder=${isServiceOrder}`);
	}
	async GetPlannedOrderDetails(ZakaznikId: number, OrderSubtypeId: number, OzakazkaId: number | null, VozidloId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPlannedOrderDetails?customerId=${ZakaznikId}&orderSubtypeId=${OrderSubtypeId}&plannedOrderId=${OzakazkaId}&vehicleId=${VozidloId}`);
	}
	async CheckHolidayForPlanAndDeliveryDate(workshopId:number, planDate:any, deliveryDate:any) {
		return this.fetch('/Administrace/Holiday/CheckHolidayForPlanAndDeliveryDate', { workshopId, planDate, deliveryDate })
	}
	async getRequiredDataForPartSelection(params: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetRequiredDataForPartSelection?partNumber=${params.partNumber}&warehouseId=${params.warehouseId}&plannedOrderId=${params.plannedOrderId}&quantity=${params.quantity}`);
	}
	
	async CheckLeave(leaveDate: any, userId:number, workshopId:number) {
		return this.fetch('/Administrace/Leaves/CheckLeave', { leaveDate, userId, workshopId });
	}
}

export const apiProvider = new OzakazkaProvider(DMS_MODULE, NAME);
